import React from "react";
import AppIcons from "../../utils/AppIcons";
import ExpectedFileForUpload from "../../model/ExpectedFileForUpload";

interface IFormInputFileProps {
  label: string;
  id: string;
  value?: string | undefined;
  keyForData?: string;
  keyForDisplay?: string;
  required?: boolean;
  disabled?: boolean;
  multipleFiles?: boolean;
  acceptedFileTypes?: string;
  uploadDetails?: string;
  onChange: (
    fieldId: string,
    keyForData: string,
    keyForDisplay: string,
    files: FileList | null,
  ) => void;
  error?: string | undefined;
  css?: string | undefined;
  expectedFilesList?: ExpectedFileForUpload[] | undefined;
}

function FormInputFile({
  label,
  id,
  value,
  keyForData = "",
  keyForDisplay = "",
  required,
  disabled,
  multipleFiles = false,
  acceptedFileTypes = "",
  uploadDetails = "",
  onChange,
  error,
  css,
  expectedFilesList = [],
}: IFormInputFileProps) {
  const textColor = value ? "text-gray-800" : "text-gray-400";
  var message = value
    ? value
    : multipleFiles
      ? "click here to select the files from disk"
      : "click here to select the file from disk";

  if (expectedFilesList.length > 0) {
    message = value
      ? value
      : expectedFilesList.length > 1
        ? "click on this box to select the following files from disk:"
        : "click on this box to select the following file from disk:";
  }

  const cursor = disabled ? "" : "cursor-pointer";
  const fileTypesMessage = multipleFiles
    ? "You can select multiple files of type: "
    : "You can select one file of type: ";

  const weHaveUploads =
    expectedFilesList.filter((item) => item.already_selected == true).length >
    0;

  return (
    <div>
      <label htmlFor={id} className="form-label">
        {label}
        {required && <>*</>}
      </label>

      <label
        htmlFor={id}
        className={`form-input text-left pl-4 border-dashed border-2 ${cursor} ${textColor} ${css}`}
      >
        {AppIcons.UPLOAD}
        <div
          className={`inline-block ${expectedFilesList.length > 0 ? "font-bold" : ""}`}
        >
          {message}
        </div>
        {expectedFilesList.length > 0 && (
          <div className="form-upload-expected-files">
            {expectedFilesList.map((item) => {
              return (
                <div
                  className={`whitespace-nowrap ${item.already_selected && weHaveUploads ? "text-green-600" : weHaveUploads ? "text-red-600" : ""}`}
                >
                  {item.already_selected && weHaveUploads && AppIcons.CHECK}
                  {!item.already_selected && weHaveUploads && AppIcons.CANCEL}
                  {item.name}
                </div>
              );
            })}
          </div>
        )}
      </label>
      <input
        type="file"
        id={id}
        accept={acceptedFileTypes}
        style={{ display: "none" }}
        multiple={multipleFiles}
        disabled={disabled}
        onChange={(e) => {
          onChange(id, keyForData, keyForDisplay, e.target.files);
        }}
      />
      {disabled && (
        <div className="form-warning">
          You cannot change this entry. Updated versions should be published as
          new entries.
        </div>
      )}
      {acceptedFileTypes && !disabled && (
        <div className="form-hint">
          {fileTypesMessage + acceptedFileTypes}
          {uploadDetails && <span>{uploadDetails}</span>}
        </div>
      )}
      {error && <div className="form-error">{error}</div>}
    </div>
  );
}

export default FormInputFile;
